/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 18th 2023, 11:09:40 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SubscriptionPlan } from "saas-subscription/schemas";
import { usePurchaseFlowStrategy } from "./usePurchaseFlowStrategy";
import { useFreePurchaseFlowStrategy } from "./useFreePurchaseFlowStrategy";
import { useTrialWithoutPayPurchaseFlowStrategy } from "./useTrialWithoutPayPurchaseFlowStrategy";
import { useContactUsStrategy } from "./useContactUsStrategy";
import { usePayUpfrontPurchaseFlowStrategy } from "./usePayUpfrontPurchaseFlowStrategy";

type PurchaseFlowStrategyType = "free" | "trialWithoutPay" | "trialWithPay" | "payUpfront" | "contactUs";

const PurchaseFlowStrategyFactory: Record<PurchaseFlowStrategyType, typeof usePurchaseFlowStrategy> = {
  free: useFreePurchaseFlowStrategy,
  trialWithoutPay: useTrialWithoutPayPurchaseFlowStrategy,
  trialWithPay: usePurchaseFlowStrategy,
  payUpfront: usePayUpfrontPurchaseFlowStrategy,
  contactUs: useContactUsStrategy,
};

export const getPurchaseFlowStrategyHook = (subscriptionPlan: SubscriptionPlan) => {
  switch (subscriptionPlan?.metadata?.product_code) {
    case "onestop-free":
      return PurchaseFlowStrategyFactory.free;
    case "onestop-enterprise":
      return PurchaseFlowStrategyFactory.contactUs;
    default:
      return PurchaseFlowStrategyFactory.payUpfront;
  }
};
